'use strict';

Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
const trackSize = require('./track-size.js');
function trackElementsSize(options) {
  const {
    getNodes,
    observeMutation = true,
    callback
  } = options;
  const cleanups = [];
  let firstNode = null;
  function trigger() {
    const elements = getNodes();
    firstNode = elements[0];
    const fns = elements.map((element, index) => trackSize.trackElementSize(element, size => {
      callback(size, index);
    }));
    cleanups.push(...fns);
  }
  trigger();
  if (observeMutation) {
    const fn = trackMutation(firstNode, trigger);
    cleanups.push(fn);
  }
  return () => {
    cleanups.forEach(cleanup => {
      cleanup === null || cleanup === void 0 || cleanup();
    });
  };
}
function trackMutation(el, cb) {
  var _el$ownerDocument$def, _el$ownerDocument;
  if (!el || !el.parentElement) return;
  const win = (_el$ownerDocument$def = (_el$ownerDocument = el.ownerDocument) === null || _el$ownerDocument === void 0 ? void 0 : _el$ownerDocument.defaultView) !== null && _el$ownerDocument$def !== void 0 ? _el$ownerDocument$def : window;
  const observer = new win.MutationObserver(() => {
    cb();
  });
  observer.observe(el.parentElement, {
    childList: true
  });
  return () => {
    observer.disconnect();
  };
}
exports.trackElementsSize = trackElementsSize;